/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import React, { Component } from 'react';



/* ========== ~~~~~~~~~~ TAB : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Tab = (props) => {
	// dummy function used by purely as a way to iterate over number of "tab" components and created PROPER structure in tabs component
	return null;
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default (Tab);
